`<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div class="h-screen flex w-full bg-img-login vx-row no-gutter items-center justify-center" id="page-login">
  <div class="vx-col sm:w-4/5 md:w-3/4 lg:w-3/5 xl:w-2/5 sm:m-0 m-4">
    <vx-card>
      <div slot="no-body" class="full-page-bg-color">

        <div class="vx-row no-gutter justify-center items-center">

          <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
            <div class="p-8 login-tabs-container">

              <div class="vx-card__title mb-4">
                <h4 class="mb-4 inline-block">{{ $t('message.login.loginHeader') }}</h4>
                <div class="inline-block float-right"><I18n></I18n></div>
              </div>

              <div class="vx-card__title mb-4" v-if="error">
                <vs-alert color="danger">{{ $t(error) }}</vs-alert>
              </div>

              <div style="min-height: 14rem">
                <LoginRestore
                  v-if="showRestore"
                  @close-restore="showRestore = false"
                ></LoginRestore>
                <LoginDownloadQr v-else-if="totpFirst" @downloaded="firstQrAdd = false" />
                <LoginBindQr v-else-if="totpSecond" @downloaded="qrBinded" />
                <LoginChangeSms
                  :username="username"
                  :password="password"
                  :passwordNew="passwordNew"
                  @confirm-code="changeSmsAction"
                  v-else-if="firstStepDone && needChangePassword"
                ></LoginChangeSms>
                <LoginChangeSms
                  :username="username"
                  :password="password"
                  :passwordNew="passwordNew"
                  @confirm-code="changeSmsAction"
                  v-else-if="firstStepDone && selfChange"
                ></LoginChangeSms>
                <LoginChangePass
                  v-else-if="selfChange || needChangePassword"
                  @error-change="setError"
                  :username="username"
                  :password="password"
                  @login-action="changeAction"
                ></LoginChangePass>
                <LoginSms v-else-if="firstStepDone && !useTotp"
                  @confirm-code="confirmCodeAction"
                  @second-code="getNextCode"
                  :error="error"
                ></LoginSms>
                <LoginOtp v-else-if="firstStepDone && useTotp"
                  @confirm-code="confirmOtpAction"
                  @first-step="firstStep"
                  :error="error"
                ></LoginOtp>
                <LoginUserPass v-else
                   @login-action="loginAction"
                   @show-restore="showRestore = true"
                   :error="error" :block="block"
                ></LoginUserPass>
              </div>

              <div>
                <a href="javascript: void(0)"
                   class="mt-16"
                   v-if="firstStepDone || totpFirst || totpSecond"
                   @click="firstStep"
                >
                  {{ $t('message.login.back') }}
                </a>
              </div>
              <a href="javascript: void(0)"
                 class="mt-16"
                 @click="activeRules = true"
              >
                {{ $t('message.login.securityRulesButton') }}
              </a>
              <div>
                <a href="javascript: void(0)"
                   class="mt-16"
                   v-if="!selfChange && !needChangePassword && !useTotp"
                   @click="selfChange = true"
                >
                  {{ $t('message.login.changePasswordButton') }}
                </a>
              </div>
              <div>
                <a href="javascript: void(0)"
                   class="mt-16"
                   v-if="(selfChange && !firstStepDone && !needChangePassword)"
                   @click="selfChange = false"
                >
                  {{ $t('message.login.backButton') }}
                </a>
              </div>
              <a href="javascript: void(0)" v-if="false" @click="$router.push({name: 'register'})">
                {{ $t('message.register.header') }}
              </a>
              <vs-popup class="holamundo"  :title="$t('message.login.securityRulesButton')" :active.sync="activeRules">
                <p v-html="$t('message.login.securityRulesText')"></p>
              </vs-popup>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import LoginSms from '@/views/pages/login/LoginSms'
import LoginOtp from '@/views/pages/login/LoginOtp'
import LoginUserPass from '@/views/pages/login/LoginUserPass'
import LoginRestore from '@/views/pages/login/LoginRestore'
import LoginChangePass from '@/views/pages/login/LoginChangePass'
import LoginChangeSms from '@/views/pages/login/LoginChangeSms'
import I18n from '@/layouts/components/navbar/components/I18n'
import LoginDownloadQr from '@/views/pages/login/LoginDownloadQr'
import LoginBindQr from '@/views/pages/login/LoginBindQr'

export default{
  data () {
    return {
      showRestore: false,
      activeRules: false,
      username: '',
      password: '',
      passwordNew: '',
      selfChange: false,
      block: false,
      firstQrAdd: true
    }
  },
  methods: {
    ...mapActions('user', ['login', 'sms', 'otp', 'change', 'changeSms', 'setError', 'clearLogin']),
    loginAction (payload) {
      this.username = payload.username
      this.password = payload.password
      this.block = true
      return this.login(payload)
        .then(() => (this.block = false))
        .catch(() => (this.block = false))
    },
    confirmCodeAction (payload) {
      this.block = true
      this.sms(payload).
        then(() => {
          if (this.loggedIn) this.$router.push({name: 'home'})
          this.block = false
        })
        .catch(() => (this.block = false))
    },
    confirmOtpAction (payload) {
      this.block = true
      this.otp(payload).
        then(() => {
          if (this.loggedIn) this.$router.push({name: 'home'})
          this.block = false
        })
        .catch(() => (this.block = false))
    },
    getNextCode (payload) {
      this.sms(payload)
    },
    changeAction (payload) {
      this.username = payload.username
      this.password = payload.password
      this.passwordNew = payload.password_new
      this.block = true
      this.change(payload)
        .then(() => (this.block = false))
        .catch(() => (this.block = false))
    },
    changeSmsAction (payload) {
      this.changeSms({
        ...payload,
        username: this.username,
        password: this.password,
        password_new: this.passwordNew
      })
    },
    firstStep () {
      this.firstQrAdd = true
      this.clearLogin()
    },
    async qrBinded () {
      await this.loginAction({
        username: this.username,
        password: this.password
      })
      this.firstQrAdd = true
    }
  },
  computed: {
    ...mapGetters('user',
      ['firstStepDone', 'error', 'needChangePassword', 'loggedIn', 'totpDevices', 'useTotp']
    ),
    ...mapMutations('user', ['setTotpDevices']),
    totpFirst () {
      return this.firstQrAdd && this.useTotp && this.totpDevices === null
    },
    totpSecond () {
      return !this.firstQrAdd && this.useTotp && this.totpDevices === null
    }
  },
  mounted () {
    if (this.loggedIn) this.$router.push({name: 'home'})

  },
  components: {
    LoginDownloadQr, LoginUserPass, LoginSms, LoginRestore, LoginChangePass, LoginChangeSms, I18n, LoginBindQr, LoginOtp
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
</style>
